import React from 'react';
import PropTypes from 'prop-types';
import { connect } from '../../../../../../../redux/connect';
import { getFlatGroupedProjectEntities, getCurrentUser } from '../../../../../../../redux/selectors';
import ChannelItemBase from '../../../../../../ChannelItemBase';
import T from 'i18n-react';
import { toLocalDateTime } from '../../../../../../../utils/date-helpers';
import { commentAttributesType, userType } from '../../../../../../../constants/proptype-validation';
import { ActivityCommentBlock } from '@adsk/bim360-matrix-react-components';

export class PureCommentDetails extends ChannelItemBase {
  render() {
    const { comment, currentUser, projectEntities } = this.props;
    const { body, createdAt, createdByDisplayName } = comment;
    return (
      <div>
        <header className="isui-channel-item__header">
          <span className="isui-channel-item__name">{createdByDisplayName || T.translate('userUndefined')}</span>
          <span className="isui-channel-item__timestamp">{toLocalDateTime(createdAt)}</span>
        </header>
        <div className="isui-channel-item__body">
          <ActivityCommentBlock comment={body} currentUser={currentUser.attributes} projectEntities={projectEntities} />
        </div>
      </div>
    );
  }
}

PureCommentDetails.displayName = 'CommentDetails';

PureCommentDetails.propTypes = {
  comment: commentAttributesType.isRequired,
  currentUser: userType.isRequired,
  projectEntities: PropTypes.array,
};

const mapStateToProps = (state) => ({
  currentUser: getCurrentUser(state),
  projectEntities: getFlatGroupedProjectEntities(state),
});

export default connect(mapStateToProps)(PureCommentDetails);
